import "./DigitalServicesOverview.css";

const ServicesOverview = () => {
  const services = [
    {
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
      title: "Tech Services",
      items: [
        "Web/App Development",
        "Cloud Service and solution",
        "Cybersecurity",
        "IT Infrastructure Service",
        "ERP Implementation",
        "Brand Strategy Development",
        "Logo& Visual Identity Design",
        "Social Media Management",
        "Search Engine Optimization (SEO)",
        "Package design",
        "Campaigning",
      ],
    },
    {
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
      title: "Digital marketing",
      items: [
        "Search Engine Optimization(SEO)",
        "Personal branding PR works",
        "Brand Strategy Development",
        "Logo& Visual Identity Design",
        "Social Media Managment (SMM)",
        "Package Designing",
        "Campaigning",
      ],
    },
  ];

  return (
    <div className="services-overview">
      <div className="container">
        <h2>Tech and Digital services</h2>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              {service.description ? (
                <p className="service-description">{service.description}</p>
              ) : (
                <ul className="service-list">
                  {service.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesOverview;
